module.exports = __webpack_public_path__ + "static/media/big-white-plus.2513d363.svg";